import { ApolloLink } from '@apollo/client';
import { onErrorLink } from '../links/onErrorLink';
import { QueueOperationLink } from '../links/QueueOperationLink';
import { ResolverImports, createGraphServerLink } from './createGraphServerLink';

/**
 * This might be a little confusing.
 *
 * These links are used by local native/web resolvers that expect there to be a client on the graphql context (context.client).  There are only
 * a couple.
 *
 * That client will look a lot like the client initialized on the main thread, but we're skipping the link that proxies it over to the worker :-).
 * For now, also skipping the policy loader link because at the time of this, no resolver is using context.client w/ lazy policies.
 */
export async function createWorkerLinks(
    context: Record<string, any>,
    resolverImports: ResolverImports
) {
    const links: Array<ApolloLink> = [];

    // Error link
    links.push(onErrorLink);

    // Queue operation link
    links.push(new QueueOperationLink());

    // Local/Remote links
    const localRemoteLink = await createGraphServerLink(context, resolverImports);
    links.push(localRemoteLink);

    return links;
}
